import { formatDateMethod2, formatDateMethod3 } from "../../utils/formatarData"

function retornaComorbidadeKey(comorbidade, comorbidadesSelecionadas, outrasComorbidades) {
  switch (comorbidade) {
    case 'Hipertensão arterial':
      comorbidadesSelecionadas.push("42")
      break
    case 'Diabetes mellitus':
      outrasComorbidades.push({ 'co_categoria': 'E14', 'no_categoria': 'Diabetes mellitus não especificado' })
      break
    case 'Dislipidemia':
      comorbidadesSelecionadas.push("48")
      break
    case 'Cardiopatia isquêmica':
      comorbidadesSelecionadas.push("44")
      break
    case 'Doença de Parkinson':
      outrasComorbidades.push({ 'co_categoria': 'G20', 'no_categoria': 'Doença de Parkinson' })
      break
    case 'Doença psiquiátrica':
      comorbidadesSelecionadas.push("45")
      break
    case 'Doenças autoimunes':
      comorbidadesSelecionadas.push("47")
      break
    case 'Outras':
      break
    case 'Ausente':
      break
    //não faz nada
    default:
      outrasComorbidades.push(comorbidade)
  }
}

function opcaoSimNao(resposta) {
  return resposta === 'Sim'
}

function historicoFamiliarOpcoes(resposta) {
  switch (resposta) {
    case 'Pai':
      return "52"
    case 'Mãe':
      return "53"
    case 'Outros':
      return "34"
    case 'Filho':
      return "54"
    case 'Irmão':
      return "55"
    default:
      break
  }
}

function primeiroSintomaOpcoes(resposta, campos) {
  switch (resposta) {
    case 'Membro superior proximal direito (elevação do braço)':
      campos.setLocalPrimeiroSintoma("1")
      break;
    case 'Membro superior proximal esquerdo (elevação do braço)':
      campos.setLocalPrimeiroSintoma("2")
      break;
    case 'Membro superior distal direito (fraqueza mão)':
      campos.setLocalPrimeiroSintoma("3")
      break;
    case 'Membro superior distal esquerdo (fraqueza mão)':
      campos.setLocalPrimeiroSintoma("4")
      break;
    case 'Membro inferior direito (perna)':
      campos.setLocalPrimeiroSintoma("5")
      break;
    case 'Membro inferior esquerdo (perna)':
      campos.setLocalPrimeiroSintoma("6")
      break;
    case 'Falta de Ar':
      campos.setLocalPrimeiroSintoma("7")
      break;
    case 'Dificuldade para engolir':
      campos.setLocalPrimeiroSintoma("8")
      break;
    case 'Dificuldade para articular palavras':
      campos.setLocalPrimeiroSintoma("9")
      break;
    case 'Não possível determinar':
      campos.setLocalPrimeiroSintoma("10")
      break;
    default:
      break
  }
}

function preencherRespostasComPerguntasDoRegistro(dados, campos) {
  if (dados['História familiar de Demência frontotemporal']) {
    if (dados['História familiar de Demência frontotemporal']['Se sim, quem']) {
      campos.setChecks(prevState => ({
        ...prevState,
        historicoDemencia: true
      }))
      let historicoDemenciaQuem = dados['História familiar de Demência frontotemporal']['Se sim, quem']
      let histFamiliar = Array.isArray(historicoDemenciaQuem) ? historicoDemenciaQuem : [historicoDemenciaQuem]
      let histFamiliarList = histFamiliar.map(function (item) {
        return historicoFamiliarOpcoes(item)
      });
      campos.setHistoricoFamiliarDemencia(histFamiliarList)
    } else {
      campos.setChecks(prevState => ({
        ...prevState,
        historicoELA: opcaoSimNao(dados['História familiar de Demência frontotemporal'])
      }))
    }
  }

  if (dados['Tratamento com riluzole*']) {
    if (dados['Tratamento com riluzole*']['Se sim, quando*']) {
      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        checked: true
      }))

      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        dataInicioUso: formatDateMethod3(dados['Tratamento com riluzole*']['Se sim, quando*'])
      }))
    } else {
      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        checked: opcaoSimNao(dados['Tratamento com riluzole*'])
      }))
    }
  }

  if (dados['Comorbidades']) {
    let comorbidade = dados['Comorbidades']
    let outrasComorbidades = []
    let comorbidadesSelecionadas = []
    comorbidade.forEach(function (item) {
      retornaComorbidadeKey(item, comorbidadesSelecionadas, outrasComorbidades)
    });
    campos.setComorbidadesSelecionadas(comorbidadesSelecionadas)
    campos.setComorbidadesOutras(outrasComorbidades)
  }
}

function preencherRespostasComPerguntasDoAutorrelato(dados, campos) {
  if (dados['Tratamento com riluzole']) {
    if (dados['Tratamento com riluzole']['Se sim, quando']) {
      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        checked: true
      }))

      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        dataInicioUso: formatDateMethod2(dados['Tratamento com riluzole']['Se sim, quando'])
      }))
    } else {
      campos.setUsoRiluzol(prevState => ({
        ...prevState,
        checked: opcaoSimNao(dados['Tratamento com riluzole'])
      }))
    }
  }
}

export default function Insert(dadosRegistro, campos) {

  let dados = dadosRegistro.registro

  if (dados['Município de residência no início da doença']) {
    let codigoEstado = dados['Município de residência no início da doença']['Código do estado']
    campos.setEstadoInicioDoenca(codigoEstado)
    campos.fetchMunicipio(codigoEstado)
    campos.setMunicipioInicioDoenca(dados['Município de residência no início da doença']['Código IBGE'])
  }

  if (dados['O primeiro sintoma iniciou-se no']) {
    primeiroSintomaOpcoes(dados['O primeiro sintoma iniciou-se no'], campos)
  }

  if (dados['Tempo de moradia nesse município']) {
    campos.setTempoMoradiaMunicipio(dados['Tempo de moradia nesse município'])
  }

  if (dados['Data do primeiro sintoma']) {
    campos.setDataPrimeiroSintoma(formatDateMethod2(dados['Data do primeiro sintoma']))
  }

  if (dados['Idade do paciente no início dos sintomas']) {
    campos.setIdadeInicioSintomas(dados['Idade do paciente no início dos sintomas'])
  }

  if (dados['Histórico familiar de ELA']) {
    if (dados['Histórico familiar de ELA']['Se sim, quem']) {
      campos.setChecks(prevState => ({
        ...prevState,
        historicoELA: true
      }))
      let historicoELAQuem = dados['Histórico familiar de ELA']['Se sim, quem']
      let histFamiliar = Array.isArray(historicoELAQuem) ? historicoELAQuem : [historicoELAQuem]
      let histFamiliarList = histFamiliar.map(function (item) {
        return historicoFamiliarOpcoes(item)
      });
      campos.setHistoricoFamiliarELA(histFamiliarList)
    } else {
      campos.setChecks(prevState => ({
        ...prevState,
        historicoELA: opcaoSimNao(dados['Histórico familiar de ELA'])
      }))
    }
  }

  if (dadosRegistro.paciente['Perfil'] === "Paciente/Autorrelato") {
    preencherRespostasComPerguntasDoAutorrelato(dados, campos)
  } else if (dadosRegistro.paciente['Perfil'] === "Paciente/Registro") {
    preencherRespostasComPerguntasDoRegistro(dados, campos)
  }

}